import {AuthenticationConverter} from './types.js';

const BASIC = 'Basic ';

export const httpBasicAuthenticationConverter = (opts?: {credentialsEncoding?: BufferEncoding}): AuthenticationConverter => {
    return async (exchange) => {
        const {request} = exchange;
        const authorization = request.headers.one("authorization");
        if (!authorization || !(/basic/i).test(authorization.substring(0,))) {
            return;
        }
        const credentials = authorization.length <= BASIC.length ? '' : authorization.substring(BASIC.length);
        const decoded = Buffer.from(credentials, 'base64').toString(opts?.credentialsEncoding ?? 'utf-8');
        const parts = decoded.split(":", 2);
        if (parts.length !== 2) {
            return undefined;
        }
        return {
            type: 'UsernamePassword',
            authenticated: false,
            principal: parts[0],
            credentials: parts[1]
        };
    }

}
